import useCalenderFilter from "../../../hooks/useCalenderFilter";
import {
  Box,
  Button,
  List,
  ListItem,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../../../styles/pages/submithome.module.scss";
import styles1 from "../../../styles/components/SubmittedPageTable/submittedTableFilter.module.scss";
import dayjs from "dayjs";
// import Image from "next/image";
import assest from "../../../json/assest";
import { DatePicker } from "@imarabinda/antd";
import { getDateApiFormat } from "../../../lib/functions/utils.lib";

const { RangePicker } = DatePicker;

// export type FilterRowProps = {
//   hideFilter?: boolean;
//   hideCalender?: boolean;
//   hideDateRangeFilter?: boolean;
//   hideSearch?: boolean;
//   hideLastItem?: boolean;
//   children?: React.ReactNode;
//   rightItems?: React.ReactNode;
//   leftItems?: React.ReactNode;
//   middleItems?: React.ReactNode;
//   FilterModalComponent?: React.JSXElementConstructor<{
//     open: boolean;
//     onClose: () => void;
//   }>;
//   filterModalProps?: React.ComponentProps<any>;
// };

import { useAppDispatch } from "../../../hooks/useAppDispatch";
import {
  setFrom,
  setTo,
  setApiActiveOne,
  setApiActiveTwo,
  setConfirmed,
} from "../../../redux-toolkit/slices/submitted.rejected.slice ";
import { useAppSelector } from "../../../hooks/useAppSelector";
import CalenderDate from "../../../pages/Calender";

export default function SubmittedRejectedFilter({
  hideFilter,
  children,
  hideCalender,
  hideDateRangeFilter,
  rightItems,
  leftItems,
  FilterModalComponent,
  filterModalProps,
  filterActive,
}) {
  const calenderContainerId = "calender-input-filter-row";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    calenderOpen,
    resetCalender,
    confirmCalender,
    confirmedCalenderValue,
    calenderValue,
    setCalenderValue,
    toggleCalender,
    closeCalender,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderContainerId,
  });
  // console.warn(
  //   "calenderValue",
  //   calenderValue ? getDateApiFormat(calenderValue[0]["$d"]) : ""
  // );

  // const [callAgain, setCallAgain] = useState(null)

  // const { from, to } = useAppSelector((s) => s.submittedPendingSlice);

  const {
    openFilterModal,
    setOpenFilterModal,
    handleTriggreFetch,
    filtersReset,
    data2,
  } = filterModalProps.p;

  // const [openFilterModal, setOpenFilterModal] = useState(false);
  const handleOpenFilterModal = useCallback(() => {
    setOpenFilterModal(true);
  }, []);
  const handleCloseFilterModal = useCallback(() => {
    setOpenFilterModal(false);
  }, []);

  const dispatch = useAppDispatch();
  const { apiActiveTwo, confirmed } = useAppSelector(
    (s) => s.submittedRejectedSlice
  );
  // console.warn('apiActiveTwo , confirmed', apiActiveTwo ,confirmed)
  const handleGoAwait = () => {
    dispatch(setConfirmed(false));
    resetCalender();
    filtersReset();
  };
  const handleGoBack = () => {
    dispatch(setConfirmed(true));
    resetCalender();
    filtersReset();
  };

  const [goback, setgoback] = useState("Awaiting Confirmation");

  useEffect(() => {
    if (calenderValue) {
      if (calenderValue[0]) {
        dispatch(setFrom(getDateApiFormat(calenderValue[0]["$d"])));
      }
      if (calenderValue[1]) {
        dispatch(setTo(getDateApiFormat(calenderValue[1]["$d"])));
      }

      handleTriggreFetch();
    }
  }, [calenderValue]);
  // console.warn('confirmedCalenderValue', confirmedCalenderValue)

  return (
    <>
      {FilterModalComponent ? (
        <FilterModalComponent
          {...filterModalProps}
          open={openFilterModal}
          onClose={handleCloseFilterModal}
        />
      ) : null}
      {!filterActive ? (
        <Box className={styles.table_left2}>
          {leftItems}
          <Box className="commonSearchBar_modal">
            <p>
              Showing videos for{" "}
              {calenderFilter ? (
                <>
                  <Box
                    className={`dayList ${
                      openedDateRangeFilter ? "date-black" : "date-blue"
                    }`}
                  >
                    <Button
                      aria-haspopup="true"
                      onClick={handleOpenDateRangeFilter}
                    >
                      {calenderFilter?.name}
                    </Button>
                    <Menu
                      anchorEl={dateRangeFilterAnchor}
                      open={openedDateRangeFilter}
                      onClose={handleCloseDateRangeFilter}
                      className="dateList"
                    >
                      {DateFilterRangeList.map((filter) => {
                        if (filter != calenderFilter) {
                          return (
                            <MenuItem
                              onClick={changeCalenderFilter(filter)}
                              key={filter.name}
                              selected={filter === calenderFilter}
                            >
                              {filter.name}
                            </MenuItem>
                          );
                        }
                      })}
                    </Menu>
                  </Box>
                  <span className="dateList">({calenderFilterShowValue})</span>
                </>
              ) : (
                <>
                  the period from{" "}
                  {confirmedCalenderValue?.[0] ? (
                    <span className="dayList">
                      {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                    </span>
                  ) : null}{" "}
                  to{" "}
                  {calenderValue?.[1] ? (
                    <span className="dayList">
                      {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                    </span>
                  ) : null}
                </>
              )}
            </p>
            {/* {calenderFilter?.name !== "Today" ? ( */}
            {calenderFilter?.name !== "All time" ? (
              <span className="reset_picker" onClick={resetCalender}>
                {/* <span className="reset_picker" onClick={handleResetCalender}> */}
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M4.22705 6.7832L6.77263 4.23762"
                    stroke="currentColor"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M6.77263 6.76238L4.22705 4.2168"
                    stroke="currentColor"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                reset
              </span>
            ) : null}
          </Box>
        </Box>
      ) : (
        <p className={styles.moreFilter}>
          Showing videos for one or more selected filters.
        </p>
      )}

      {/* <Box className={styles.table_middle}>
        {middleItems}
        {!hideSearch ? (
          <Box className={styles.table_search}>
            <input type="text" placeholder="Enter an email address, submitter name, VSID to search..." />
          </Box>
        ) : null}
      </Box> */}

      <Box className={`${styles.table_right} ${styles1.awaitingButton}`}>
        {/* <Button className={styles.pendingBtn}>Pending Revision</Button> */}
        {apiActiveTwo && !confirmed && (
          <Button
            onClick={handleGoBack}
            onMouseOver={() => setgoback("Go Back")}
            onMouseLeave={() => setgoback("Awaiting confirmation")}
            className={styles1.awaitingActive}
          >
            {goback}
          </Button>
        )}
        {apiActiveTwo && confirmed && (
          <Button
            disabled={data2?.data?.data?.length < 1}
            onClick={handleGoAwait}
            className={styles.awaitingInactive}
          >
            Awaiting Confirmation
          </Button>
        )}
        <List>
          {!hideFilter ? (
            <ListItem className={styles.table_filter}>
              <a href="#" onClick={handleOpenFilterModal}>
                <img
                  src={assest.filterIconBlack}
                  width={14}
                  height={16}
                  alt=""
                />
              </a>
            </ListItem>
          ) : null}

          <CalenderDate confirmCalender={confirmCalenderTwo} />
        </List>
        {rightItems}
      </Box>
      {children}
    </>
  );
}
